import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
	createQuiz,
	deleteQuiz,
	getQuizList,
	getQuizListByBranchId,
	updateQuiz,
} from '@/api/services/direcionada/administration/quiz'
import type { ApiResponse } from '@/types'
import type {
	QuizInput,
	QuizListOutput,
	QuizOutput,
	QuizParams,
} from '@/types/quiz'

export function useQuizList(params?: QuizParams) {
	return useQuery<ApiResponse<QuizListOutput>, Error, QuizListOutput>({
		queryKey: ['quiz', params],
		queryFn: () => getQuizList(params),
		staleTime: 10 * 60 * 1000, // 10 minutos
	})
}

export function useQuizListByBranchId(branchId: string) {
	return useQuery<ApiResponse<QuizOutput[]>, Error, QuizOutput[]>({
		queryKey: ['quiz', branchId],
		queryFn: () => getQuizListByBranchId(branchId),
		// Sem branch selecionada a URL viraria /quizzes/branch/ (404 no backend)
		enabled: Boolean(branchId),
		staleTime: 10 * 60 * 1000, // 10 minutos
	})
}

export function useCreateQuiz() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: createQuiz,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['quiz'] })
			// a nota informada no cadastro aparece no menu Pontuação
			queryClient.invalidateQueries({ queryKey: ['scoring'] })
		},
	})
}

export function useUpdateQuiz() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: QuizInput }) =>
			updateQuiz(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['quiz'] })
			// a nota informada no cadastro aparece no menu Pontuação
			queryClient.invalidateQueries({ queryKey: ['scoring'] })
		},
	})
}

export function useDeleteQuiz() {
	const queryClient = useQueryClient()
	return useMutation({
		mutationFn: deleteQuiz,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['quiz'] })
		},
	})
}
